import Ajax from '../../../../../common/js/Ajax.js';
import Form from '../../../../../common/js/form/Form.js';
import MessageUtils from '../../../../../common/js/MessageUtils.js';
import TippspielWidget from '../../TippspielWidget.js';
import ZeptoUtils from '../../../../../common/js/ZeptoUtils.js';

import TEAMS_TEMPLATE from './TeamsWidget-teams.hbs';

export default class TeamsWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}

	isLoginRequired() {
		return true;
	}

	isAdminRequired() {
		return true;
	}

	onLoginReady() {
		this.refresh();

		Form.onSubmit(this.$widget.find('.js_create-team'), action => {
			var $name = action.findField('name');
			Ajax.rpc('/createTeam', {name: $name.val()}, () => {
				$name.val('');
				action.ok();
				this.refresh();
			}, error => {
				action.error('Anlegen des Teams fehlgeschlagen', error);
			});
		});
	}

	refresh() {
		Ajax.rpc('/teams', teams => {
			this.$widget.find('.js_teams').html(TEAMS_TEMPLATE(teams));

			this.$widget.find('.js_delete').click(event => {
				var $team = $(event.currentTarget).closest('.js_team');
				Ajax.rpc('/deleteTeam', {id: $team.attr('data-id')}, () => {
					this.refresh();
				}, error => {
					MessageUtils.error(this.$widget, 'Löschen des Teams fehlgeschlagen', error);
				});
			});
		}, error => {
			MessageUtils.error(this.$widget, 'Laden der Teams fehlgeschlagen', error);
		});
	}
}
